@if (showFirstLast()) {
    <button
        mat-icon-button
        [disabled]="prevDisabled()"
        (click)="first()">
        <mat-icon>first_page</mat-icon>
    </button>
}
<button
    mat-icon-button
    [disabled]="prevDisabled()"
    (click)="prev()">
    <mat-icon>chevron_left</mat-icon>
</button>
@if (labelFormat() === PagerLabelFormat.Page) {
    <span
        class="st-pager-label"
        [matMenuTriggerFor]="pagesMenu">
        {{ label() }}
    </span>
    <mat-menu
        #pagesMenu="matMenu"
        class="st-pager-menu">
        <ng-template matMenuContent>
            <mat-selection-list
                hideSingleSelectionIndicator
                [multiple]="false"
                (selectionChange)="goToPage($event)">
                @for (page of pagesList(); track page) {
                    <mat-list-option [value]="$index">Page {{ page }}</mat-list-option>
                }
            </mat-selection-list>
        </ng-template>
    </mat-menu>
} @else {
    <span class="st-pager-label">{{ label() }}</span>
}
<button
    mat-icon-button
    [disabled]="nextDisabled()"
    (click)="next()">
    <mat-icon>chevron_right</mat-icon>
</button>
@if (showFirstLast()) {
    <button
        mat-icon-button
        [disabled]="nextDisabled()"
        (click)="last()">
        <mat-icon>last_page</mat-icon>
    </button>
}
